// libs/common is shared with the backend, so it names the Firebase SDK's types, never an Angular wrapper's (OE-213).
import firebase from 'firebase/compat/app';
import { Particle } from '../../classes/particle';
import { Folder } from './app.models';

export interface Workspace {
    id: string;
    inbasketCount: number;
    pendingCount: number;
    filedCount: number;
    particles: firebase.firestore.DocumentReference<Particle>;
    cachedRecipients: firebase.firestore.DocumentReference<{ emailAddress: string }>;
    folders: firebase.firestore.DocumentReference<Folder>;
}
